const APP_LOGIN =
  (import.meta.env.VITE_APP_LOGIN_URL as string | undefined) ||
  "https://app.icraftx.com/login";

for (const id of ["login-cta", "login-nav"] as const) {
  const el = document.getElementById(id);
  if (el instanceof HTMLAnchorElement) {
    el.href = APP_LOGIN;
  }
}
